/**
 * Asserts that all properties in the given object are non-nullable.
 *
 * @throws Error if any property is null or undefined.
 * @param data Object with properties to check.
 *
 * Usage:
 * assertRequiredData(myData);
 * // TypeScript now knows all properties in myData are non-nullable
 */
export function assertRequiredData<T extends object>(
  data: T
): asserts data is { [K in keyof T]: NonNullable<T[K]> } {
  for (const key in data) {
    if (data[key] === null || data[key] === undefined) {
      throw new Error(`Missing required data: ${key}`);
    }
  }
}

export const notNill = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};
